export default function (breakpoint, offset, selector = '.logo-gtue') {
    const isLarge = window.innerWidth >= breakpoint;
    const logoElement = document.querySelector(selector);

    window.addEventListener('scroll', () => {
        if (isLarge) {
            if (window.scrollY >= offset) {
                logoElement.classList.add('small');
            } else {
                logoElement.classList.remove('small');
            }
        }
    });
}